import { Box, Text } from '@factorialco/deprecated-design-system'

import type { BenefitItem } from 'modules/benefits/pages/BenefitsLanding/_Content/countryContent'

interface BenefitCardLeftProps {
  benefit: BenefitItem
}

const BenefitCardLeft = ({ benefit }: BenefitCardLeftProps) => {
  return (
    <Box className="flex items-center md:flex-row" gap="s24">
      <Box borderRadius={{ all: 'abs016' }} overflowX="hidden" className="w-full md:w-1/2">
        <video
          src={benefit.media.src}
          style={{ width: '100%', height: 'auto', display: 'block' }}
          autoPlay
          muted
          loop
        />
      </Box>
      <Box gap="s16" className="w-full md:w-[30%] px-6">
        <Text size="400" weight="semibold" color="black" className="">
          {benefit.title}
        </Text>
        <Text size="300">{benefit.description}</Text>
      </Box>
    </Box>
  )
}

export default BenefitCardLeft
